export const MessageStrategyTypes = Symbol('MessageStrategy');
